import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import UpdateUserInfo from "./UpdateUserInfo";
import UpdateVenueDetails from "./UpdateVenueDetails";
import { API_USER_INFO } from "../../Util/URLConstants";
import {
  SESSION_USER_COUNTRY_CODE_KEY,
  SESSION_USER_COUNTRY_DATA_KEY,
  SESSION_USER_ID_KEY,
  SESSION_USER_IMAGE_KEY,
  SESSION_USER_MOBILE_NO_KEY,
  SESSION_USER_NAME_KEY,
  SESSION_USER_ROLES_PERMISSIONS,
} from "../../Util/VMConstants";
import axios from "axios";
import StorageFactory from "../../Util/StorageFactory";
import UpdateSubvenueDetails from "./UpdateSubvenueDetails";
import { align_center, VM_Colors } from "../../Styles/VMStyles";
import RoomsInfo from "./RoomsInfo";
import Loader from "../../Components/Loader";
import { normalizeLoginPermissions } from "../../Util/UtilHelper";

function VMProfile() {
  const [userState, setUserState] = useState(null);
  const [venueState, setVenueState] = useState(null);
  const [subVenueState, setSubVenueState] = useState(null);
  const [loading, setLoading] = useState(false);
  const sessionFactory = new StorageFactory("session");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getUserInfo = () => {
    setLoading(true);
    const userID = sessionFactory.get(SESSION_USER_ID_KEY);
    axios
      .get(API_USER_INFO + "?user_id=" + userID)
      .then((resp) => {
        setLoading(false);
        const respData = resp.data;
        const userProfile = respData.user_info;

        // Save to session storage — add cache-busting to ensure fresh image load
        sessionFactory.add(SESSION_USER_NAME_KEY, userProfile.name);
        sessionFactory.add(SESSION_USER_COUNTRY_CODE_KEY, userProfile.country_code);
        sessionFactory.add(SESSION_USER_COUNTRY_DATA_KEY, userProfile.country_data);
        sessionFactory.add(SESSION_USER_MOBILE_NO_KEY, userProfile.mobile_no);
        sessionFactory.add(SESSION_USER_IMAGE_KEY, userProfile.image_url);
        // Keep role permissions in sync with DB (login session can be stale after role edits)
        if (userProfile.permissions != null) {
          sessionFactory.add(
            SESSION_USER_ROLES_PERMISSIONS,
            normalizeLoginPermissions(userProfile.permissions)
          );
        }

        // dispatch custom event so Navbar updates in same tab
        window.dispatchEvent(new Event("userImageUpdated"));

        setUserState(respData.user_info);
        setVenueState(respData.venue_info);
        setSubVenueState(respData.subvenue_info);
      })
      .catch((err) => {
        console.error("Error fetching user info:", err);
        setLoading(false);
      });
  };

  const loadProfile = () => {
    getUserInfo();
  };

  useEffect(() => {
    getUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: VM_Colors.white1,
        paddingLeft: "10px",
        paddingRight: "10px",
        paddingBottom: "10px",
        ml: { xs: 0, sm: 0, md: 0, lg: 5 },
      }}
    >
      {userState && <UpdateUserInfo userState={userState} loadProfile={loadProfile} />}
      {venueState && (
        <UpdateVenueDetails venueState={venueState} loadProfile={loadProfile} editable={true} />
      )}
      {subVenueState && (
        <UpdateSubvenueDetails
          getUserInfo={getUserInfo}
          venueState={venueState}
          subVenueState={subVenueState}
          loadProfile={loadProfile}
        />
      )}
       <Box mt={2}>
              {userState && <RoomsInfo userState={userState} />}
        </Box> 

     <Box sx={{ position: "relative" ,...align_center}}>
     {loading ? <CircularProgress loading={loading} /> : null}
     </Box>
    </Box>
  );
}

export default VMProfile;